<template>
  <TypeformTitle :title="`${store.applicationForm.opportunityTitle}`"
                 :subtitle="`Join the ${store.applicationForm.companyName} Team Today`" center>

    <div ref="container"/>

    <TypeformButtons
      class="mt-6 flex justify-center items-center"
      animate
      :defaultText="isFinishing ? 'Finish Application' : 'Start Application'"
      @prevStep="$emit('prevStep')"
      @nextStep="$emit('nextStep')" />

    <div :class="animateClass"
         style="--anim-delay: 400ms;--to-opacity: 0.7;"
         class="flex items-center justify-center space-x-1 font-medium opacity-70 mt-4 mb-12">
      <ClockIcon class="h-4 w-4"/>
      <p>{{ estimatedCompletionTime }}</p>
    </div>

  </TypeformTitle>
</template>

<script setup>
import TypeformButtons from "./TypeformButtons.vue";
import TypeformTitle from "./TypeformTitle.vue";
import {ClockIcon} from "@heroicons/vue/20/solid/index.js";
import {onBeforeMount, onMounted, ref} from "vue";
import {useAnimateInTrigger} from "../composables/AnimateInComposable";
import {useCandidateApplicationFormStore} from "../stores/CandidateApplicationFormStore";
import {useParseResumeStore} from "../stores/ParseResumeStore";
import {useAccountStore} from "../stores/AccountStore";

const store = useCandidateApplicationFormStore();
const parseResumeStore = useParseResumeStore();
const accountStore = useAccountStore();

const emits = defineEmits(["prevStep", "nextStep", "update:validating", "update:validator"]);
defineProps({
  stepCount: Number,
  estimatedCompletionTime: String,
  isFirstStep: Boolean,
  isLastStep: Boolean,
});

const container = ref();
const animateClass = ref("animate-in-vars-pre");

const isFinishing = window.location.search.includes("apply=1") && window.location.search.includes("finish=1");

useAnimateInTrigger(container, (className) => animateClass.value = className);

onBeforeMount(() => {
  if (!accountStore.isLoggedIn) parseResumeStore.attemptToLoadOldResume();
});

onMounted(() => {
  emits("update:validating", false);
  emits("update:validator", async () => true);
});
</script>
